import { queryOptions, useQuery } from '@tanstack/react-query';

import { getRecipeHomepage } from '../queries/recipe';
import { useAuthStore } from '../stores';
import { RECIPE_QUERY_KEY } from './useGetRecipeList';

export function getRecipeHomepageOptions(
  access_token: string,
  enabled = true
) {
  return queryOptions({
    queryKey: [RECIPE_QUERY_KEY, 'homepage'],
    queryFn: () => getRecipeHomepage(access_token),
    enabled,
    retry: false,
    refetchOnWindowFocus: (q) => q.state.data !== undefined,
  });
}

export const useGetRecipeHomepage = (enabled = true) => {
  const session = useAuthStore();
  return useQuery(getRecipeHomepageOptions(session.access_token, enabled));
};
